var React = require('react');

function AsanaTree (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","strokeWidth":"2","strokeMiterlimit":"10","d":"M17,24c0,4.063,2,13,2,13h-5 M17,2.013\n\tc0,0-6,3.343-6,7.987c0,3.125,2,5,2,5s0,2,0,8c0,4.415,1.232,7.5,3.5,14 M17.688,29.09c4.88,0,7.312-0.965,7.312-2.527\n\tc0-2.965-4-4.813-4-4.813c0-6,0-6.75,0-6.75s2-2,2-5c0-4.645-6-7.987-6-7.987V0 M17,7c-1.104,0-2,1.343-2,3s0.896,3,2,3s2-1.343,2-3\n\tS18.104,7,17,7z"}));
}

AsanaTree.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"38px","height":"38px","viewBox":"0 0 38 38","enableBackground":"new 0 0 38 38","xmlSpace":"preserve"};

module.exports = AsanaTree;

AsanaTree.default = AsanaTree;
